import { Button, Grid } from "@material-ui/core";
import React, { useState } from "react";
import { LSDBCoreTable } from "../../../common/LSDBCoreTable";
import { RsdVirtualTraveler } from "./ProcedureTraveler/RsdVirtualTraveler";

export const TestSequenceDialog = ({ serialNumberData, report_result }: any) => {


  const [selectedSerial, setSelectedSerial] = useState<string | null>(null);
  const [openRsdVirtualDialog, setOpenRsdVirtualDialog] = React.useState(false);

  const handleOpen = (serialNumber: string) => {
    setSelectedSerial(serialNumber);
    setOpenRsdVirtualDialog(!openRsdVirtualDialog);
  };
  
  


  const columns = React.useMemo(

    () => [
      {
        id: "Id",
        accessor: "unit_id",
      },

      {
        Header: "Serial Number             ",
        accessor: "serial_number",

        Cell: ({ row }: any) => (
          <Button
            variant="contained"
            color="primary"
            
            onClick={() => handleOpen(row.values.serial_number)}
          >
            {row.values.serial_number}
          </Button>
        )

      },
      {
        accessor: "test_sequence_definition_name",
        id: "test_sequence_definition_name",
        Cell: ({ row }: any) => {
          return row.values.test_sequence === null ? (
            <p>N/A</p>
          ) : (
            <p>{row.values.test_sequence_definition_name}</p>
          );
        }
      }

    ],
    []
  );

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      spacing={4}
    >
      <Grid item xs={12}>
        <LSDBCoreTable columns={columns} data={serialNumberData} hiddenColumns={["Id"]} />
      </Grid>
      {selectedSerial && (
        <RsdVirtualTraveler serialNumber={selectedSerial} report_data={report_result} travelerOpen={openRsdVirtualDialog} handleTraveler={handleOpen} />
      )}
    </Grid>

  );

}